import React, { Component } from 'react'
import { Route } from 'react-router-dom'

import Asset from './components/Asset'
// import Assets from './components/Assets'
// import Sensors from './components/Sensors'
import Callback from './components/Callback'
import NavBar from './components/NavBar'
import Resources from './components/Resources'
import Sensor from './components/Sensor'

import { MODEL_ASSET_FIELDS, MODEL_SENSOR_FIELDS, MODEL_ASSET_TYPE_FIELDS } from './models.js'
// <Route exact path='/assets' component={ Assets } />

class App extends Component {
  render() {
    return (
      <div>
        <NavBar />
        <Route exact path='/callback' component={ Callback } />
        <Route exact path='/assets' render={(props) => <Resources {...props} resourceType="assets" fields={MODEL_ASSET_FIELDS} />}  />
        <Route exact path='/assets/:assetId' component={ Asset } />
        <Route exact path='/sensors' render={(props) => <Resources {...props} resourceType="sensors" idField="dev_eui" fields={MODEL_SENSOR_FIELDS} />}  />
        <Route exact path='/sensors/:devEUI' component={ Sensor } />
        <Route exact path='/asset_types' render={(props) => <Resources {...props} resourceType="asset_types" fields={MODEL_ASSET_TYPE_FIELDS} />}  />
      </div>
    );
  }
}

export default App;